export default __webpack_public_path__ + "locales/pt/FormGallery.json?hash=41a431056b3634784842d91680cbcd7e";